import React, { useEffect } from 'react'
import {
  Button,
  Form as BForm,
  Row,
  Col,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from '@themesberg/react-bootstrap'
import { Formik, Form, ErrorMessage } from 'formik'
import Toggle from "./Toggle";
import { categorySchema } from '../schema' // Update this if needed
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDollarSign,
  faInfoCircle,
  faSave,
} from "@fortawesome/free-solid-svg-icons";

const CreateCasinoCategory = ({
  handleClose,
  data,
  show,
  type,
  loading,
  createProvider,
  updateProvider,
  formikRef
}) => {
  const { REACT_APP_S3_URL } = process.env;
  return (
    <>

      <Formik
        enableReinitialize
        innerRef={formikRef}
        initialValues={{
          gameCategoryId: data?.gameCategoryId,
          name: data?.name || '',
          isActive: data?.is_active || false,
          image: data?.categoryImage,
          gameLimit: Number(data?.gameLimit)
        }}
        validationSchema={categorySchema} // Should validate `name` as string
        onSubmit={(formValues) => {
          const formData = new FormData();
          formData.append("name", formValues.name);
          formData.append("isActive", formValues.isActive);
          formData.append("gameLimit", formValues.gameLimit);
          // Add image/file if it exists
          if (formValues.image && formValues.image instanceof File) {
            formData.append("categoryImage", formValues.image); // must be a File object
          }

          if (data?.gameCategoryId) {
            formData.append("gameCategoryId", formValues.gameCategoryId);
            updateProvider(formData, { gameCategoryId: data?.gameCategoryId });
          } else {
            formData.append("categoryType", 'featured');
            console.log(formData, formValues, "formDataformData")
            createProvider(formData);
          }

          handleClose();
        }}

      >
        {({ values, handleChange, handleSubmit, handleBlur, setFieldValue }) => (
          <Form>
            <Modal
              show={show}
              onHide={handleClose}
              backdrop='static'
              keyboard={false}
            >
              <Modal.Header closeButton>
                <Modal.Title>{type} Category </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row className='mt-3'>
                  <Col>
                    <BForm.Label>
                      Category Name
                    </BForm.Label>
                    <BForm.Control
                      type='text'
                      name='name'
                      placeholder='Enter Category Name'
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      component='div'
                      name='name'
                      className='text-danger'
                    />
                  </Col>
                </Row>



                <Row className='mt-3'>
                  <Col>
                    <BForm.Label>
                      Category Image <span className='text-danger'>*</span>
                      <OverlayTrigger
                        placement="right"
                        overlay={
                          <Tooltip id={`tooltip-`}>
                            {"It's recommended to Upload Icons in SVG and PNG formats"}
                          </Tooltip>
                        }
                      >
                        <span className="ms-2">
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            className="text-warning"
                          />
                        </span>
                      </OverlayTrigger>

                    </BForm.Label>
                    <BForm.Control
                      type='file'
                      name='image'
                      accept='.png,.svg'
                      onChange={(event) => {
                        setFieldValue('image', event.currentTarget.files[0]);
                      }}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      component='div'
                      name='image'
                      className='text-danger'
                    />
                  </Col>

                  {values.image && (
                    <div className="mt-3">
                      {values.image instanceof File ? (
                        <img
                          src={URL.createObjectURL(values.image)}
                          alt="Preview"
                          style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }}
                        />
                      ) : (
                        <img
                          src={`${REACT_APP_S3_URL}/${values.image}`} // already a URL
                          alt="Preview"
                          style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }}
                        />
                      )}
                    </div>
                  )}

                </Row>

                {/* game limit  */}
                <Row className='mt-3'>
                  <Col>
                    <BForm.Label>
                      Game Limit  <span className='text-danger'>*</span>
                    </BForm.Label>
                    <BForm.Control
                      type='number'
                      name='gameLimit'
                      value={values.gameLimit}
                      placeholder='Enter Game Limit'
                      // accept='.png,.svg,.jpeg,.jpg'
                      onChange={(e) => setFieldValue('gameLimit', e.target.value)}
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      component='div'
                      name='gameLimit'
                      className='text-danger'
                    />
                  </Col>



                </Row>
                <Row className='mt-3'>
                  <BForm.Label>
                    Status
                  </BForm.Label>

                  <Row className="mt-1">
                    <Col className="d-flex justify-content-start">
                      <Toggle
                        checked={values.isActive}
                        onChange={(e) => setFieldValue('isActive', e.target.checked)}
                        size="small"
                      />
                    </Col>
                  </Row>
                </Row>


              </Modal.Body>

              <Modal.Footer className='d-flex justify-content-between align-items-center'>
                <Button className='btn-danger' onClick={handleClose}>
                  Cancel
                </Button>
                <Button className='btn-primary' onClick={handleSubmit}>
                  Submit
                  {loading && (
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    />
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </Form>
        )}
      </Formik>

    </>
  )
}

export default CreateCasinoCategory
